import Raven from 'raven-js';

Raven.config(SENTRY_WEB_DSN, {
  allowDuplicates: true,
  shouldSendCallback() {
    return !__DEVELOPMENT__;
  },
}).install();

export default Raven;
